module.exports = require("core-js/modules/es.regexp.constructor.js");